import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from 'environments/environment';
import { FileUploader } from 'ng2-file-upload';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit {
  ticketId: string;
  baseApi: string;
  @Input('ticketId') set setId(value: string) {
    if (value) {
      this.ticketId = value;
      if(this.uploader) this.uploader.destroy();
      this.baseApi = environment.apiUrl + `uploadAttachments/${this.ticketId}`;
      this.uploader = new FileUploader({
        url: this.baseApi,
        autoUpload: true,
        maxFileSize: this.maxFileSize * 1024 * 1024
      });
      this.uploader.onCompleteAll = () => {
        this.files.emit(this.uploader.queue.map(x => x.file.name));
        setTimeout(() => {
          this.emitSubmitDisable.emit(false);
        }, 100);
      };
    }
  }
  public uploader: FileUploader;
  @Output() files: EventEmitter<any> = new EventEmitter<any>();

  public hasBaseDropZoneOver: boolean = false;
  @Output() emitSubmitDisable: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() maxFileSize: number;
  @Input('resetQueue') set resetFiles(value: number) {
    if (value > 0) {
      this.uploader.cancelAll();
      this.uploader.clearQueue();
    }
  }
  constructor() { }
  ngOnInit() {
   
  }

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }
  removeAttachment() {
    this.files.emit(this.uploader.queue.map(x => x.file.name));
  }

  disableSubmit() {
    setTimeout(() => {
      this.emitSubmitDisable.emit(true);
    }, 100);
  }
}
